export default __webpack_public_path__ + "static/media/limit_30.e22d9498.svg";